import HighlightedTabs from '@shared/components/tabs/HighlightedTabs';
import * as React from 'react';
import { useContext } from 'react';
import { InputBase, Paper, Snackbar, Alert, } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  ContentListFilterContext,
  ContentListFilterContextValue,
} from '@view/content-management-system/context/ContentListFilterContext';
import useIsMobile from '@hooks/use-breakpoint/useIsMobile';
import { TextKeys } from '@lib/i18n/configureI18n';
import { useTranslation } from 'react-i18next';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';

const ContentListTabs: React.FC<unknown> = () => {
  const { search, tabs } = useContext(
    ContentListFilterContext,
  ) as ContentListFilterContextValue;

  const [tabIndex, setTabIndex] = React.useState(0);
  const [searchKeyword, setSearchKeyword] = React.useState('');

  const isMobile = useIsMobile();
  const { t } = useTranslation();
  // Toast state
  const [openToast, setOpenToast] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState('');
  const [toastSeverity, setToastSeverity] = React.useState<'success' | 'error'>('success');

  React.useEffect(() => {
    tabs.setValue(tabIndex);
  }, [tabIndex, tabs]);

  React.useEffect(() => {
    search.setValue(searchKeyword);
  }, [search, searchKeyword]);

  const renderSearchBar = () => {
    return (
      <Paper
        component="form"
        className="subtitle2"
        sx={{
          p: '2px 2px',
          display: 'flex',
          alignItems: 'center',
          width: 663,
          height: 34,
          borderRadius: '100px',
          backgroundColor: '#fff',
        }}
      >
        <SearchIcon
          className="text-on-primary"
          sx={{
            p: '10px',
            width: isMobile ? 20 : 40,
            height: 40,
          }}
        />
        <InputBase
          onChange={(e) => setSearchKeyword(e.target.value)}
          value={searchKeyword}
          sx={{ ml: 1, flex: 1 }}
          placeholder={isMobile ? 'Search' : 'Search projects'}
          inputProps={{ 'aria-label': isMobile ? 'Search' : 'Search projects' }}
        />
      </Paper>
    );
  };

  const handleCloseToast = (event?: React.SyntheticEvent | Event, reason?: string) => {
    setOpenToast(false);
  };
  // Custom toast function
  const showToast = (message: string, severity: 'success' | 'error') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setOpenToast(true);
  };


  return (
    <div className="flex flex-col justify-between w-full mt-10 mb-1">
      {/* SEARCH BAR */}
      <div className="flex flex-col items-center">
        {renderSearchBar()}
      </div>
      {/* TOOL BAR */}
      <div className="flex items-center justify-between bg-white shadow w-full mt-10">
        {/* Left Section: Checkbox + Tabs */}
        <div className="flex items-center ml-5 gap-4">
          <input type="checkbox" className="w-4 h-4 m-2 mr-5 ml-4" />
          <div className="ml-5" >
            <HighlightedTabs
              tabs={tabs.options}
              selectedTab={tabIndex}
              onTabChanged={setTabIndex}
            />
          </div>
        </div>

        {/* Right Section: Count + Actions */}
        <div className="flex items-center gap-4 justify-between mr-5">

          <div className="font-bold text-sm mr-5">
            ? {t(TextKeys.ProjectSelected)}
            {/* to be implemented later */}
          </div>
          <div>
            <button
              className="mr-5 ml-5"
              onClick={() => {
                showToast('Copied successfully (to be implemented)', 'success');// placeholder for copy action
                // Implement the copy action here
              }}>
              <ContentCopyIcon className="font-bold text-tertiary" fontSize="small"
                sx={{
                  p: '10px',
                  width: isMobile ? 20 : 40,
                  height: 40,
                }} />
              <span className="font-bold text-tertiary">{t(TextKeys.CopyProject)}</span>
            </button>
            <button
              className="mr-5 ml-5"
              onClick={() => {
                showToast('Delete successfully (to be implemented)', 'error');// placeholder for delete action
                // Implement the delete action here
              }}>
              <DeleteIcon className="font-bold text-error" fontSize="small"
                sx={{
                  p: '10px',
                  width: isMobile ? 20 : 40,
                  height: 40,
                }} />
              <span className="font-bold text-error">{t(TextKeys.DeleteProject)}</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <Snackbar
          open={openToast}
          autoHideDuration={6000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            onClose={handleCloseToast}
            severity={toastSeverity}
            sx={{ width: '100%' }}
          >
            {toastMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default ContentListTabs;
